// i18n area 'auth' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.uk-UA.meta.json.
import type { enUS } from './auth'

export const ukUA: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Увійдіть у свій обліковий запис',
    username: 'Ім’я користувача',
    usernamePlaceholder: 'Введіть ім’я користувача',
    usernameHint: 'Використовуйте користувач@домен, щоб автентифікуватися в реалмі каталогу',
    continue: 'Продовжити',
    changeUser: 'Це не ви?',
    password: 'Пароль',
    forgotPassword: 'Забули пароль?',
    submit: 'Увійти',
    otp: 'Одноразовий код',
    otpSubtitle: 'Введіть код зі свого автентифікатора',
    otpHint: 'Шість цифр із застосунку автентифікації або один із кодів відновлення',
    otpSubmit: 'Перевірити',
    invalidCredentials: 'Неправильне ім’я користувача або пароль',
    tooManyAttempts: 'Забагато спроб — зачекайте хвилину і спробуйте ще раз',
    realmUnavailable: 'Реалм зараз не може перевірити облікові дані — сховище конфігурації кластера недоступне. Увійдіть як локальний користувач (break-glass).',
    genericError: 'Не вдалося увійти — чи доступний бекенд TVirt?'
  },
  user: {
    logout: 'Вийти',
    password: {
      menu: 'Змінити пароль',
      title: 'Зміна вашого пароля',
      current: 'Поточний пароль',
      new: 'Новий пароль',
      confirm: 'Підтвердьте новий пароль',
      mismatch: 'Паролі не збігаються',
      error: 'Не вдалося змінити пароль',
      forcedTitle: 'Змініть пароль, щоб продовжити',
      forcedHint: 'Цей пароль встановив адміністратор, і його потрібно замінити перед входом.',
      forcedSubmit: 'Змінити та увійти'
    },
    mfa: {
      title: 'Двофакторна автентифікація',
      subtitle: 'Другий фактор, обов’язковий за кожного входу',
      loadError: 'Не вдалося завантажити стан другого фактора',
      enrolled: 'Активний',
      notEnrolled: 'Не активний',
      enrolledAt: 'Активовано',
      codesRemaining: 'Залишилося кодів відновлення',
      requiredHint:
        'Адміністратор вимагає другий фактор для цього облікового запису: налаштуйте його зараз — доки цього не зробите, ви зможете увійти, але майже нічого більше.',
      enroll: 'Налаштувати',
      enrollTitle: 'Налаштування двофакторної автентифікації',
      enrollHint: 'Наведіть застосунок автентифікації на цей код, а потім введіть код, який він покаже, для підтвердження.',
      secretHint: 'Не вдається його зчитати? Введіть цей секрет у застосунку:',
      code: 'Код із застосунку',
      confirm: 'Підтвердити',
      startError: 'Не вдалося розпочати налаштування',
      confirmError: 'Не вдалося підтвердити налаштування',
      codesTitle: 'Ваші коди відновлення',
      codesWarning:
        'Ці коди показуються лише один раз. Збережіть їх зараз: кожен із них дає вхід, коли автентифікатор недоступний, і діє лише один раз.',
      codesAck: 'Я зберіг коди відновлення',
      codesDone: 'Готово',
      copy: 'Копіювати',
      copied: 'Скопійовано',
      download: 'Завантажити',
      regenerate: 'Нові коди відновлення',
      regenerateTitle: 'Перегенерувати коди відновлення',
      regenerateHint: 'Усі видані досі коди перестають працювати тієї миті, коли створюється новий набір.',
      regenerateConfirm: 'Перегенерувати',
      regenerateError: 'Не вдалося перегенерувати коди відновлення',
      remove: 'Вилучити',
      removeTitle: 'Вилучити другий фактор',
      removeConfirm: 'Вилучити',
      removeHint: 'Обліковий запис повертається лише до пароля. Ви можете будь-коли налаштувати другий фактор знову.',
      removeRequiredHint:
        'Адміністратор вимагає другий фактор для цього облікового запису, тому сервер відхилить вилучення — спершу попросіть зняти цю вимогу.',
      removeError: 'Не вдалося вилучити другий фактор'
    },
    profile: {
      menu: 'Перейти до мого профілю',
      sessions: 'Активні сеанси',
      sessionsHint: 'Ваші відкриті сеанси на цьому вузлі',
      sessionsEmpty: 'Активних сеансів немає',
      sessionCreated: 'Вхід виконано',
      sessionExpires: 'Спливає',
      revoke: 'Відкликати сеанс',
      revokeError: 'Не вдалося відкликати сеанс',
      loadError: 'Не вдалося завантажити сеанси'
    }
  }
}
